/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Title_SimpleInputs */

const en_byoa_title_simple = /** @type {(inputs: Byoa_Title_SimpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your own AI key`)
};

const id_byoa_title_simple = /** @type {(inputs: Byoa_Title_SimpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai kunci AI-mu sendiri`)
};

/**
* | output |
* | --- |
* | "Use your own AI key" |
*
* @param {Byoa_Title_SimpleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_title_simple = /** @type {((inputs?: Byoa_Title_SimpleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Title_SimpleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_title_simple(inputs)
	return en_byoa_title_simple(inputs)
});